import { createFeature, createReducer, on } from '@ngrx/store';
import { User } from '@models';
import { UserActions } from './user.actions';

interface UserState {
  current: User | null;
  loading: boolean;
  error: string | null;
}

const initialUserState: UserState = {
  current: null,
  loading: false,
  error: null,
};

export const userFeature = createFeature({
  name: 'user',
  reducer: createReducer(
    initialUserState,
    on(UserActions.loadCurrent, (state): UserState => ({ ...state, loading: true, error: null })),
    on(UserActions.loadCurrentSucceeded, (state, { user }): UserState => ({ ...state, current: user, loading: false })),
    on(UserActions.loadCurrentFailed, (state, { error }): UserState => ({ ...state, error, loading: false })),
    on(UserActions.setCurrent, (state, { user }): UserState => ({ ...state, current: user })),
    on(UserActions.cleared, (): UserState => initialUserState)
  ),
});
